module.exports = __webpack_public_path__ + "media/night/200-ffbe2f7d.svg";